import React from "react";

import MaterialTable from "material-table";
import { formatDateDDMMYYYYHHMM } from "../../../../../plas/utils";
import es from "date-fns/locale/es";

import CreationForm from "./call-creation-form";

import service from "../../../../../plas/services/calls/service.jsx";

function TableCalls( { open } ) {

  const [create, setCreate] = React.useState(false);
  const tableRef = React.useRef();
  
  return (
    <div>
      <MaterialTable
        tableRef={tableRef}
        localization={{
          pagination: {
            labelDisplayedRows: "{from}-{to} de {count}",
            labelRowsPerPage: "Filas por página",
            labelRowsSelect: "Filas",
            firstAriaLabel: "Primera página",
            firstTooltip: "Primera página",
            previousAriaLabel: "Página anterior",
            previousTooltip: "Página anterior",
            nextAriaLabel: "Próxima página",
            nextTooltip: "Próxima página",
            lastAriaLabel: "Última página",
            lastTooltip: "Última página",
          },
          toolbar: {
            nRowsSelected: "{0} filas(s) seleccionadas",
            searchTooltip: "Buscar",
            searchPlaceholder: "Buscar",
          },
          header: {
            actions: "Acciones",
          },
          body: {
            dateTimePickerLocalization: es,
            emptyDataSourceMessage: "No hay convocatorias para mostrar",
            deleteTooltip: "Eliminar",
            editTooltip: "Editar",
            filterRow: {
              filterTooltip: "Filtrar",
            },
            editRow: {
              saveTooltip: "Confirmar",
              cancelTooltip: "Cancelar",
              deleteText: "¿Está seguro que desea eliminar la convocatoria?",
            },
          },
        }}
        title="Convocatorias"
        columns={[
          { title: "ID", field: "id",  editable: "never", cellStyle: {width:"5%"}, headerStyle:{width:"5%"},
            render: rowData => <span>{rowData.id}</span> },
          { title: "Nombre", field: "name", sorting: false, cellStyle: {width:"30%"}, headerStyle:{width:"30%"},
            render: rowData => <span>{rowData.name}</span> },
          { title: "Estado", field: "state", editable: "never", sorting: false, cellStyle: {width:"20%"}, headerStyle:{width:"20%"},
            render: rowData => <span>{ rowData.getStateDescription().name }</span> },
          { title: "Apertura", field: "startDate",sorting: false, cellStyle: {width:"20%"}, headerStyle:{width:"20%"},
            render: rowData => <span>{ formatDateDDMMYYYYHHMM(rowData.startDate)} </span> },
          { title: "Cierre", field: "endDate", sorting: false, cellStyle: {width:"20%"}, headerStyle:{width:"20%"},
            render: rowData => <span>{ formatDateDDMMYYYYHHMM(rowData.endDate) }</span> },
          { title: "Postulaciones", editable: "never", field: "applications",sorting: false, cellStyle: {width:"10%"}, headerStyle:{width:"10%"},
            render: rowData => <span>{ rowData.applications }</span> }
        ]}
        actions={[
          rowData => ({
            icon: "launch",
            tooltip: "Abrir",
            onClick: (event, rowData) => open(event, rowData)
          }),
          {
            icon: "add",
            tooltip: "Crear convocatoria",
            isFreeAction: true,
            onClick: (event) => { setCreate(true); },
          },
        ]}
        options={{
          pageSize: 10,
          sorting: false,
          draggable: false,
          addRowPosition: "first",
          actionsColumnIndex: -1,
          tableLayout: 'auto',
          actionsCellStyle: {width: "10%"},
          rowStyle: {
            fontSize: 15,
          }
        }}
        data={ query =>
          new Promise((resolve, reject) => {
            let from = query.page * query.pageSize;
            let to = from + query.pageSize;
            let keyword = query.search;

            service.api.calls.getPage(from,to,0,Date.now()+315400000000,keyword,(response) => {
              if (response.result != null) {
                resolve({
                  data: response.result.data,
                  page: query.page,
                  totalCount: response.result.total,
                });
              } else {
                reject();
              }
            }); 
          })
        }
      />
      <CreationForm 
        open={create} 
        cancel={() => {
          setCreate(false)
        }} 
        created={() => { 
          setCreate(false); 
          if (tableRef.current != undefined && tableRef.current != null) {
            tableRef.current.onQueryChange()
          }
        }}/>
    </div>
  );

}

export default TableCalls;
